<template>
    <div class="menu-bar z-40 max-md:border-b  dark:border-neutral-700 fixed py-1.5 max-md:px-1" :class="$page.props.url?.split('/').at('-1') !== 'app' ? 'backdrop-blur-lg' : ''">
        <div class="items flex items-center">
            <div class="w-1/3 flex items-center gap-1.5">

                <div v-if="!isMobile" class="border rounded-full flex dark:border-neutral-700 border-gray-300 overflow-hidden mr-1">
                    <Button :label="$t('common.nav_forms')" size="small" icon="pi pi-check-square" variant="text"
                            :class="$page.component === 'administration/views/list/FormListView' ? '!bg-blue-100 dark:!bg-gray-800 dark:!text-white !rounded-none' : ''"
                            severity="secondary" @click="router.visit('/app/forms')"></Button>
                    <div class="border-l border-gray-300 dark:border-neutral-700"></div>
                    <Button :label="$t('common.nav_reservations')" size="small" icon="pi pi-calendar" variant="text"
                            :class="$page.component === 'administration/views/ReservationsView' ? '!bg-blue-100 dark:!bg-gray-800 dark:!text-white !rounded-none' : ''"
                            severity="secondary" @click="router.visit('/app/reservations')"></Button>
                </div>
                <SplitButton v-if="false" label="Přidat" icon="pi pi-plus" @click="router.visit('/app/forms/wizard')" rounded size="small" :model="[
                { label: 'Nový formulář pomocí průvodce', icon: 'pi pi-plus' },
                { separator: true },
                { label: 'Nový formulář pro sjednání online schůzek', icon: 'pi pi-phone' },
                { label: 'Nová osobní rezervační stránka', icon: 'pi pi-user' },
            ]" />
                <div class="grow mx-3">
                    <slot></slot>
                </div>
            </div>
            <div class="w-1/3 flex items-center justify-center gap-1.5">
                <div class="bg-beta-light-logo dark:bg-beta-dark-logo rr-logo bg-no-repeat cursor-pointer"
                     @click="router.visit('/app/forms')"/>
            </div>
            <div class="w-1/3 flex items-center justify-end gap-1.5">
                <credits-counter></credits-counter>
                <div id="feedback-topbar"></div>
                <Button class="max-md:!hidden" icon="pi pi-cog" @click="emit('open-settings')" variant="text" size="large" severity="secondary"
                        rounded></Button>
                <div class="relative" @click="($event) => {
                notificationsPopover.toggle($event);
                numberOfSeenNotifications = displayedNotifications.length;
            }">
                    <Badge v-if="displayedNotifications.length" :value="displayedNotifications.length" size="small" :severity="displayedNotifications.length !== numberOfSeenNotifications ? 'danger' : 'contrast'" class="absolute z-50 right-0 cursor-pointer"></Badge>
                    <Button icon="pi pi-bell" variant="text" size="large" severity="secondary" rounded></Button>
                </div>
                <Button v-if="false" icon="pi pi-question-circle" variant="text" size="large" severity="secondary" rounded></Button>
                <Avatar v-if="$page.props.user" :label="$page.props.user_initials" shape="circle" :image="profile"
                        @click="toggle" class="ml-1 cursor-pointer" size="normal"/>
                <Menu ref="menu" :model="account_items" id="overlay_tmenu" popup/>
            </div>




        </div>
        <Popover ref="notificationsPopover" class="!rounded-2xl">
            <div class="p-1 w-80">
                <div class="flex justify-between mb-2 items-center">
                    <h3 class="text-lg font-semibold">{{ $t('common.notifications') }}</h3>
                    <Button v-if="displayedNotifications.length" :label="$t('common.mark_all_read')" @click="markAllAsRead" size="small" severity="secondary"></Button>
                </div>

                <template v-if="displayedNotifications.length">
                    <div class="flex flex-col gap-2">
                        <div
                            v-for="notification in displayedNotifications"
                            :key="notification.id"
                            class="bg-white dark:bg-neutral-800 dark:border-neutral-700 shadow rounded-lg p-3 flex gap-3 cursor-pointer hover:shadow-md transition-all border border-gray-200 items-center relative mouseoverable"
                            :class="{ 'opacity-50': notification.read_at }"
                            @click="showDialog(notification)">

                            <div class="relative mt-0.5">
                                <Avatar :label="getInitials(notification.data.sender)"></Avatar>
                                <p class="absolute -bottom-1 -right-1 bg-blue-500 text-white h-5 flex justify-center align-center break-words items-center border-2 border-white dark:border-neutral-800 w-5 rounded-full">
                                    <i class="pi" :class="notification.data.type === 'new_reservation' ? 'pi-plus' : ((notification.data.change_request?.action === 'cancel' || notification.data.type === 'canceled_reservation' ) ? 'pi-trash' : 'pi-arrow-right-arrow-left')" style="font-size: .5rem!important"></i>
                                </p>
                            </div>
                            <div class="text-xs grow overflow-hidden">
                                <p class="text-sm break-words">{{notification.data.message}}</p>
                                <span class="opacity-50">{{ useFormatDate().formatDate(notification.created_at) }}</span>
                            </div>

                            <div class="flex gap-3 justify-between show-mouseover">
                                <i v-if="false" class="pi pi-eye text-blue-600 cursor-pointer"></i>
                                <i class="pi pi-trash text-blue-600 cursor-pointer" @click.stop="markAsRead(notification.id)"></i>
                            </div>
                        </div>
                    </div>

                    <!-- Stránkování -->
                    <div v-if="notifications.length > pageSize" class="mt-3 text-center">
                        <button
                            @click="loadMore"
                            class="text-roori-blue font-semibold text-xs hover:underline"
                        >
                            {{ $t('common.load_more') }}
                        </button>
                    </div>
                </template>

                <template v-else>
                    <p class="text-gray-500 text-sm">{{ $t('common.no_notifications') }}</p>
                </template>
            </div>
        </Popover>

    </div>
    <notification-click-dialog v-model="currentNotification" @read="markAsRead(currentNotification?.id)"></notification-click-dialog>
    <div class="menu-bar-dummy"></div>
</template>
<script setup>
import Avatar from 'primevue/avatar';
import Menu from 'primevue/menu';
import {Badge} from "primevue";
import {
    computed,
    ref
} from 'vue';
import {Deferred, router, usePage} from "@inertiajs/vue3";
import Popover from "primevue/popover";
import Button from "primevue/button";
import {getInitials, useFormatDate} from "../../../../helpers.js";
import { trans } from 'laravel-vue-i18n';
import {SplitButton} from "primevue";
import NotificationClickDialog from "./notifications/NotificationClickDialog.vue";
import CreditsCounter from "./CreditsCounter.vue";

defineProps({
    isMobile: Boolean
})
const menu = ref();
const emit = defineEmits(['open-settings'])

const profile = computed(() => {
    return null;
})

const notifications = computed(() => usePage().props.notifications);
const readNotifications = ref([]);

const pageSize = 8;
const currentPage = ref(1);

const displayedNotifications = computed(() => notifications.value?.filter(el => !readNotifications.value?.includes(el.id))?.slice(0, currentPage.value * pageSize))

const currentNotification = ref();

const showDialog = (notification) => {
    currentNotification.value = notification;
}

const loadMore = () => {
    currentPage.value++;
};

const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("cs-CZ", {
        day: "numeric",
        month: "short",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const numberOfSeenNotifications = ref()

const markAsRead = (notification) => {
    try {
        axios.put('/notification_read/' + notification, {  })
        readNotifications.value.push(notification);
    } catch (error) {
        console.error("Chyba při označení jako přečtené:", error);
    }
};
const markAllAsRead = () => {
    try {
        axios.put('/notification_all_read', {  })
        readNotifications.value = notifications.value.map(el => el.id);
    } catch (error) {
        console.error("Chyba při označení jako přečtené:", error);
    }
};

const notificationsPopover = ref()

const toggle = (event) => {
    menu.value.toggle(event);
}
const account_items = ref([{
    label: trans('common.nav_user_settings'),
    icon: 'pi pi-fw pi-user',
    command: () => {
        emit('open-settings');
    }
},
    {
        label: trans('common.nav_logout'),
        icon: 'pi pi-sign-out',
        badge: 2,
        command: () => {
            router.get('/logout')
        }
    }
]);
</script>
<style scoped lang="scss">
.menu-bar-dummy {
    height: 57px;
    @media screen and (min-width: 769px)
    {
        height: 75px;
    }
}

.menu-bar {
    width: 100%;

    .items {
        display: flex;
        max-width: 1900px;
        margin: 0 auto;
        padding-left: 20px;
        padding-right: 20px;

        .spacer {
            width: 100%;
        }

        .item {
            width: 200px;

            &:last-child {
                text-align: right;
            }
        }
    }
}

.rr-logo {
    height: 42px;
    width: 120px;
    margin-top: -3px;
    margin-bottom: -3px;
}
.show-mouseover {
    opacity: 0;
}
.mouseoverable:hover {
    .show-mouseover {
        opacity: 1;
    }
}
</style>
